import React from 'react';
import { CTAButton } from './CTAButton';
import { PRICE } from './salesData';
export function FinalCta() {
  return <section className="bg-white pb-10 pt-11 sm:pb-14 sm:pt-16" data-id="element-52" data-mp="vg7qnzl5q2i9">
      <div className="mx-auto max-w-md px-5 text-center sm:max-w-2xl" data-id="element-53" data-mp="19epc1qnlb2x0">
        <h2 className="mx-auto max-w-[24ch] font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-54" data-mp="19cuoe4kxowp8">
          No se trata de leer 200 fórmulas.
          <span className="mt-1.5 block font-accent text-[1.1rem] font-medium tracking-normal text-gold-deep sm:text-[1.45rem]" data-id="element-55" data-mp="1jb22mfnu90nj">
            Se trata de encontrar el primer jabón que quieras fabricar.
          </span>
        </h2>

        <p className="mt-5 font-sans text-[0.95rem] font-semibold text-charcoal" data-id="element-56" data-mp="1o43lszv2vmcx">
          <span className="mr-2 font-medium text-taupe" style={{
          textDecoration: 'line-through'
        }} data-id="element-57" data-mp="1o67oxfl5khc5">
            {PRICE.previous}
          </span>
          {PRICE.current} ARS · pago único
        </p>

        <div className="mt-4 flex justify-center" data-id="element-58" data-mp="1x2p2sqkwitbl">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-59" data-mp="n6w7h09dnscq" />
        </div>
      </div>
    </section>;
}